export const sessionToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfdXVpZCI6ImNiMGQwZjgxLWVhYzQtNDZkNi05YmQ2LTYwNWE2OTkyZjE1OCIsInVzZXJfdXVpZCI6IjFhZjViNDJkLTEyZTctNGU5Yy1iYjRmLWFiMjJiYTQ2Nzc1YiIsIndoaXRlbGFiZWxfdXVpZCI6IjM0ZWI3NmQ1LTc4MmItNGRlYi1iZjY1LTA2ZjkwM2JkYjhjZiIsImJ1aWxkaW5nX3V1aWQiOiI0NjU1MzdjNy05OTljLTQzZGEtYjhkMC00NjYxYmM1MmU4OWQiLCJ2ZXJzaW9uIjoxLCJpYXQiOjE1MTYyMzkwMjJ9.nA8nLyyqaifFIwISWlPDLYEoPCccd8rDHn9CrUNkFtU';

export const base_url = 'https://hqo.dev';
export const mockedTheme = {
  primary1: '#ffffff',
  primary2: '#eeeeee',
};
export const mockedInitialRoute = 'initial-route';

export const mockedBrand = 'MOCKED_BRAND';

export const mockedCompany = {
  uuid: '39d49260-718d-4add-add8-e124589d9a1a',
  name: 'HqO',
};

export const mockedGetTokenizeCard = { card_id: 1795, token: 'PAYMENT_TOKEN' };

export const mockedBuilding = {
  name: 'Test Building',
  uuid: 'a102770a-5018-40dd-92ae-ae5246dba201',
  address_1: '38 Chauncy St',
  city: 'Boston',
  administrative_area_1: 'MA',
  country_code: 'US',
  theme: mockedTheme,
};

export const mockedUser = {
  first_name: 'Test',
  last_name: 'User',
  email: 'test@test.com',
  uuid: '5760976f-28ce-441d-8e1a-cce01aa2e21e',
  company: mockedCompany,
};

export const mockedHostInfo = {
  host: {
    version: base_url,
    theme: mockedTheme,
  },
};

export const mockedJWTToken = 'MOCKED_JWT';
